import { render, staticRenderFns } from "./CatalogFilter.vue?vue&type=template&id=3a0518fe&"
import script from "./CatalogFilter.vue?vue&type=script&lang=ts&"
export * from "./CatalogFilter.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports